import * as React from "react"

const SvgComponent = ({color, ...props}) => (
  <svg
    width={18}
    height={11}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.297.129a.426.426 0 0 0-.456.04C10.791.92 7.742 2.92 6.336 2.92h-.02c-1.781-.02-4.534 0-4.554 0h-.079c-.04 0-.455.1-.851.436-.377.316-.832.89-.832 1.9 0 .733.198 1.288.594 1.664.495.475 1.109.475 1.168.475h.12l.95 2.891a.915.915 0 0 0 .87.634c.1 0 .199-.02.298-.04a.909.909 0 0 0 .574-1.148l-.772-2.357c.891-.02 1.92-.04 2.713-.02.455 0 1.386.198 3.247 1.169a33.333 33.333 0 0 1 2.099 1.188c.08.04.159.06.238.06.079 0 .138-.02.198-.06a.425.425 0 0 0 .217-.376V.505a.372.372 0 0 0-.217-.376Zm-.634 8.416c-.396-.238-.91-.535-1.505-.832-1.604-.832-2.812-1.248-3.623-1.267V3.772c.831-.079 2.04-.574 3.564-1.465.614-.356 1.148-.713 1.544-.97v7.208h.02ZM14.891 3.357c.08 0 .159-.02.218-.059l2.158-1.327a.441.441 0 0 0 .139-.594.44.44 0 0 0-.594-.138l-2.139 1.326a.441.441 0 0 0-.138.594c.079.12.217.198.356.198ZM17.267 7.851 15.11 6.525a.441.441 0 0 0-.594.138.441.441 0 0 0 .139.594l2.158 1.327c.08.04.139.06.218.06.138 0 .277-.08.356-.199.159-.198.08-.475-.119-.594ZM17.584 4.484h-2.653a.44.44 0 0 0-.436.436.44.44 0 0 0 .436.436h2.633A.44.44 0 0 0 18 4.92c0-.257-.178-.436-.416-.436Z"
      fill={color}
    />
  </svg>
)

export default SvgComponent
